const encode = (value) => encodeURIComponent(String(value ?? ''));

export const clubPortalBase = (eventId, venueId) =>
  `/portal/${encode(eventId)}/club/${encode(venueId)}`;

export const secretaryPortalBase = (eventId) => `/portal/${encode(eventId)}/secretary`;

export const clubRinkQrPrintPath = (eventId, venueId) =>
  `${clubPortalBase(eventId, venueId)}/print/rinks`;

export const clubSectionQrPrintPath = (eventId, venueId) =>
  `${clubPortalBase(eventId, venueId)}/print/sections`;

export const secretaryRinkQrPrintPath = (eventId) =>
  `${secretaryPortalBase(eventId)}/print/rinks`;

export const secretarySectionQrPrintPath = (eventId) =>
  `${secretaryPortalBase(eventId)}/print/sections`;

export const clubSectionPath = (eventId, venueId, sectionId) =>
  `${clubPortalBase(eventId, venueId)}/sections/${encode(sectionId)}`;

export const clubGamePath = (eventId, venueId, sectionId, gameId) =>
  `${clubSectionPath(eventId, venueId, sectionId)}/games/${encode(gameId)}`;

export const secretaryClubPath = (eventId, venueId) =>
  `${secretaryPortalBase(eventId)}/clubs/${encode(venueId)}`;

export const secretarySectionPath = (eventId, venueId, sectionId) =>
  `${secretaryClubPath(eventId, venueId)}/sections/${encode(sectionId)}`;

export const secretaryGamePath = (eventId, venueId, sectionId, gameId) =>
  `${secretarySectionPath(eventId, venueId, sectionId)}/games/${encode(gameId)}`;

export const portalUrl = (path) => `${window.location.origin}${path}`;

// The TV log pages are public embeds. Passing a venue name scopes the log to
// the sections played there; omitting it keeps the whole-event view.
const tvLogsPath = (path, eventId, venueName) => {
  const query = venueName ? `?venue=${encode(venueName)}` : '';
  return `${path}/${encode(eventId)}${query}`;
};

export const tvLogsUrl = (eventId, venueName = '') =>
  portalUrl(tvLogsPath('/embed/tvlogs', eventId, venueName));

export const tvLogsScrollingUrl = (eventId, venueName = '') =>
  portalUrl(tvLogsPath('/embed/tvlogsscrolling', eventId, venueName));

export const formatPortalEventDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

export const formatPortalDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
